import React from 'react'
import Login from 'app/Components/Login/login'

const LoginPage = () => {
  return <Login />
}

export default LoginPage
